import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    clientName: {
        validations: []
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please select a type of event' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    notes: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    reference: {
        validations: [
            { type: 'required', message: 'Please select an option' }
        ]
      }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name (required)',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name (required)',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name (optional) ',
            mapping: 'clientName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email (required)',
            mapping: 'email'
          },
         ]
        },
        {
         fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'Type of Event (required)',
            options: [
              { label: 'Wedding' , value: 'Wedding'},
              { label: 'Corporate', value: 'Corporate' },
              { label: 'Fashion Show', value: 'Fashion Show' },
              { label: 'Fundraiser', value: 'Fundraiser' },
              { label: 'Concert', value: 'Concert' },
              { label: 'Trade Show', value: 'Trade Show' },
              { label: 'Sports', value: 'Sports' },
              { label: 'Rollerskating', value: 'Rollerskating' },
              { label: 'Party', value: 'Party' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event (required)',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'How did you hear about us? (required)',
            options: [
              { label: 'Repeat Client' , value: 'Repeat Client'},
              { label: 'Client Referral', value: 'Client Referral' },
              { label: 'Website (www.exdoevents.com)', value: 'Website' },
              { label: 'Planner (Event, Caterer)', value: 'Planner' },
              { label: 'Owner Referral', value: 'Owner Referral' },
              { label: 'Employee Referral', value: 'Employee Referral' },
              { label: 'Happy Hour Networking', value: 'Happy Hour Networking' },
              { label: 'Mailing', value: 'Mailing' },
              { label: 'Cold Contact', value: 'Cold Contact' }
            ],
            mapping: 'reference'
          }
        ]
      },      
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Additional Comments',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Factory at Walnut Contact Form',
    formId: '170',
    clientKey: '13419F1F-46BB-450D-BE12-24FECE47C527',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for your submission',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/walnut/form_structure.js